<template>
  <div class="page-wrapper">
    <div class="container-fluid">  

        <h1>Contact</h1>
        <!--<div class="paper">
          <span v-for="(contact, index) in contactWays" :key="index">
            {{ contact.name }}: {{ contact.value }}<br />
          </span>
        </div>-->
        <div class="contact-info">
          <span class="text">email:</span><br/>
          <span>aleksray.info@gmail.com</span><br/><br/>
          <a target="_black" href="https://mk.linkedin.com/in/aleksandar-rajkovchevski">LinkedIn</a><br/><br/>
          <a target="_black" href="https://www.facebook.com/aleksray.fb">Facebook</a><br/><br/>
          <a target="_black" href="https://rajkovchevskialeksandar.wordpress.com">Previous portfolio</a><br/><br/>
        </div>


        <div class="nice-day">
          <img src="@/assets/contact/butterfly.webp" alt="butterfly">
          Have a nice day!:)
        </div>
          
    </div><!-- end .container-fluid -->
  </div><!-- end .page-wrapper -->
</template>

<script>
export default {
  data(){
    return {
      //contactWays: [
      //  { name: 'email', value: 'aleksray.info@gmail.com'},
      //  { name: 'location', value: 'Skopje, North Macedonia'}
      //]
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  background: url(@/assets/contact/contact-bg.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

}

.nice-day {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-size: 30px;
  color: white;
  text-shadow: 0 0 10px black;
  width: 400px;
  text-align: center;
}

.nice-day img {
  width: 50px;
}

.container-fluid {
  padding-bottom: 100px;
  /*backdrop-filter: brightness(70%);*/
  min-height: 100vh;
  /*min-width: 100vw;*/
  max-width: 1000px;
  position: relative;
}

h1, .contact-info a {
  color: white;
  text-shadow: 0 0 5px black;
  
}

.contact-info span {
  /*border-radius: 20px;*/
  background: none !important;
  color: black !important;
  text-shadow: none !important;
}

.contact-info span.text {
  /*float: left;*/
  font-size: 20px;
}

.contact-info text {
  color: silver; 
  background: none; 
  font-weight: bold;
}

.contact-info {
  background-image: url(@/assets/contact/paper2.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.contact-info span, .contact-info a {
  color: white;
  /*background: rgba(238, 0, 255, 0.6);*/
  /*border-radius: 10px;*/
  padding: 10px;
  background-image: url(@/assets/contact/paper.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* Set the background color with opacity */
  background-color: rgba(255, 255, 255, 0.9);
}

.contact-info span {
  padding: 3.3px;
}

.contact-info a {
  /*text-decoration: underline;*/
  /*border-left: 2px solid black;*/
  border-bottom: 2px solid black;
  transition: all 0.4s ease-out;
}

.contact-info a:hover {
  text-shadow: 0 0 20px white;
  text-decoration: none;
  border-color: white;
}

.contact-info {
  font-size: 23px;
  padding: 50px;
  background-size: 100% 100%;
  text-align: center;
  font-weight: bold;
  display: inline-block;
  /*width: max-content;*/
}

@media screen and (max-width: 480px) {
  .contact-info {
    font-size: 22px;
    display: block;
    padding: 50px 0;
    margin: 0 auto;
  }
}

.paper {
  /*background: url(@/assets/contact/paper.png);*/
  /*background: linear-gradient(45deg,rgb(254,205,165) 0%,rgb(254,45,45) 50%,rgb(255, 183, 0) 100%);;*/
  font-size: 20px;
  padding: 50px;
  background-size: 100% 100%;
  text-align: center;
  font-weight: bold;
  /*margin-inline: auto;*/
  width: max-content;
}

h1 {
  font-weight: bold;
}

p {
  /*margin-top: 5px;*/
  text-align: justify;
  font-size: 18px;
}

.v-center {
  display: inline-block;
  vertical-align: middle;
  float: none;
}

</style>
